<template>
  <div class="admin-api-key-manage">
    <h2>API Key 管理</h2>
    <el-form :inline="true" :model="searchForm" @submit.native.prevent="onSearch" :label-position="isMobile ? 'top' : 'right'" style="margin-bottom: 16px;">
      <el-form-item label="用户">
        <div class="user-search-container">
          <el-select v-model="userSearchType" placeholder="搜索类型" size="small" style="width: 90px; margin-right: 5px;">
            <el-option label="用户名" value="username"></el-option>
            <el-option label="用户ID" value="user_id"></el-option>
          </el-select>
          <el-input 
            v-model="searchForm.userSearch" 
            :placeholder="userSearchType === 'username' ? '输入用户名' : '输入用户ID'" 
            style="width: 120px" 
            @keyup.enter.native="onSearch" 
            size="small" 
          />
        </div>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchForm.status" placeholder="全部" clearable style="width: 120px">
          <el-option label="全部" value="" />
          <el-option label="启用" value="1" />
          <el-option label="禁用" value="0" />
          <el-option label="封禁" value="blocked" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- PC端表格 -->
    <el-table v-if="!isMobile" :data="list" border stripe style="width: 100%" v-loading="loading">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column label="用户" min-width="160">
        <template slot-scope="scope">
          <span>
            {{ scope.row.username ? scope.row.username + '（' + scope.row.user_id + '）' : '未知用户（' + scope.row.user_id + '）' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="api_key" label="API Key" min-width="260" />
      <el-table-column label="配额" width="100">
        <template slot-scope="scope">
          <el-tooltip content="配额不再限制总请求次数，仅作为参考值" placement="top">
            <span>{{ scope.row.quota }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.blocked_until && new Date(scope.row.blocked_until) > new Date()" type="danger">封禁</el-tag>
          <el-tag v-else :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '启用' : '禁用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="封禁到期" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.blocked_until && new Date(scope.row.blocked_until) > new Date()">
            {{ scope.row.blocked_until_formatted || scope.row.blocked_until }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180" />
      <el-table-column label="操作" width="280">
        <template slot-scope="scope">
          <div class="action-buttons">
            <!-- 封禁状态下显示解除封禁按钮 -->
            <el-button 
              v-if="scope.row.blocked_until && new Date(scope.row.blocked_until) > new Date()" 
              type="primary" 
              size="mini" 
              icon="el-icon-unlock"
              @click="onUnblock(scope.row)">解除封禁</el-button>
            <!-- 非封禁状态下显示启用/禁用按钮 -->
            <template v-else>
              <el-button v-if="scope.row.status === 1" type="warning" size="mini" icon="el-icon-lock" @click="onDisable(scope.row)">禁用</el-button>
              <el-button v-else type="success" size="mini" icon="el-icon-check" @click="onEnable(scope.row)">启用</el-button>
            </template>
            <el-button type="info" size="mini" icon="el-icon-refresh" @click="onReset(scope.row)">重置Key</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="onDelete(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 移动端卡片列表 -->
    <div v-else class="mobile-card-list">
      <div v-for="item in list" :key="item.id || item.api_key" class="mobile-card">
        <div class="mobile-card-title">API Key: {{ item.api_key }}</div>
        <div class="mobile-card-row">用户：{{ item.username ? item.username + '（' + item.user_id + '）' : '未知用户（' + item.user_id + '）' }}</div>
        <div class="mobile-card-row">
          配额：{{ item.quota }}
          <el-tooltip content="配额不再限制总请求次数，仅作为参考值" placement="top">
            <i class="el-icon-info" style="margin-left: 5px; color: #909399;"></i>
          </el-tooltip>
        </div>
        <div class="mobile-card-row">
          状态：
          <el-tag v-if="item.blocked_until && new Date(item.blocked_until) > new Date()" type="danger">封禁</el-tag>
          <el-tag v-else :type="item.status === 1 ? 'success' : 'info'">{{ item.status === 1 ? '启用' : '禁用' }}</el-tag>
        </div>
        <div class="mobile-card-row" v-if="item.blocked_until && new Date(item.blocked_until) > new Date()">
          封禁到期：{{ item.blocked_until_formatted || item.blocked_until }}
        </div>
        <div class="mobile-card-row">创建时间：{{ item.create_time }}</div>
        <div class="mobile-card-actions">
          <!-- 封禁状态下显示解除封禁按钮 -->
          <el-button 
            v-if="item.blocked_until && new Date(item.blocked_until) > new Date()" 
            type="primary" 
            size="mini" 
            icon="el-icon-unlock"
            @click="onUnblock(item)">解除封禁</el-button>
          <!-- 非封禁状态下显示启用/禁用按钮 -->
          <template v-else>
            <el-button v-if="item.status === 1" type="warning" size="mini" icon="el-icon-lock" @click="onDisable(item)">禁用</el-button>
            <el-button v-else type="success" size="mini" icon="el-icon-check" @click="onEnable(item)">启用</el-button>
          </template>
          <el-button type="info" size="mini" icon="el-icon-refresh" @click="onReset(item)">重置Key</el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="onDelete(item)">删除</el-button>
        </div>
      </div>
      <div v-if="!list.length && !loading" class="no-data-tip">暂无数据</div>
    </div>
    <el-pagination
      style="margin: 16px 0; text-align: right"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="searchForm.page"
      :page-size="searchForm.pageSize"
      :total="total"
      @current-change="onPageChange"
      @size-change="onSizeChange"
      :page-sizes="[10, 20, 50, 100]"
    />
    
    <!-- 显示新API Key的对话框 -->
    <el-dialog
      title="API Key已重置"
      :visible.sync="resetDialogVisible"
      width="500px"
      center
    >
      <div style="text-align: center;">
        <p>新的API Key已生成，请妥善保管：</p>
        <div style="margin: 20px 0; position: relative;">
          <el-input v-model="newApiKey" readonly style="width: 100%;" />
          <el-button 
            type="text" 
            style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%);" 
            @click="copyNewApiKey"
          >
            复制
          </el-button>
        </div>
        <p style="color: #F56C6C; font-weight: bold;">注意：此API Key仅显示一次，请立即复制并保存！</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resetDialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AdminApiKeyManage',
  data() {
    return {
      searchForm: { userSearch: '', status: '', page: 1, pageSize: 20 },
      list: [],
      total: 0,
      loading: false,
      isMobile: false,
      userSearchType: 'username', // 默认按用户名搜索
      resetDialogVisible: false,
      newApiKey: ''
    }
  },
  created() { this.onSearch(); this.checkMobile(); window.addEventListener('resize', this.checkMobile); },
  destroyed() { window.removeEventListener('resize', this.checkMobile); },
  methods: {
    checkMobile() { this.isMobile = window.innerWidth < 768; },
    async onSearch() {
      this.loading = true;
      try {
        const params = { ...this.searchForm };
        
        // 根据搜索类型处理用户搜索参数
        if (params.userSearch) {
          if (this.userSearchType === 'username') {
            params.username = params.userSearch;
          } else if (this.userSearchType === 'user_id') {
            params.user_id = params.userSearch;
          }
          delete params.userSearch; // 删除中间变量
        }
        
        console.log('Search params:', params); // 调试日志
        
        const res = await this.$axios.get('/admin/api_key/list', { params });
        if (res && res.code === 200) {
          this.list = res.data;
          this.total = res.total;
        } else {
          this.$message.error(res?.message || '获取数据失败');
        }
      } catch (err) {
        console.error('获取API Key列表失败:', err);
        this.$message.error('获取API Key列表失败: ' + (err.message || '未知错误'));
      } finally { 
        this.loading = false; 
      }
    },
    onPageChange(page) { this.searchForm.page = page; this.onSearch(); },
    onSizeChange(size) { this.searchForm.pageSize = size; this.searchForm.page = 1; this.onSearch(); },
    async onDisable(row) {
      this.$confirm('确定要禁用该API Key吗？', '提示', { type: 'warning' }).then(async () => {
        await this.$axios.post('/admin/api_key/disable', { api_key: row.api_key });
        this.$message.success('已禁用');
        this.onSearch();
      });
    },
    async onEnable(row) {
      this.$confirm('确定要启用该API Key吗？', '提示', { type: 'warning' }).then(async () => {
        await this.$axios.post('/admin/api_key/enable', { api_key: row.api_key });
        this.$message.success('已启用');
        this.onSearch();
      });
    },
    async onDelete(row) {
      this.$confirm('确定要删除该API Key吗？', '提示', { type: 'warning' }).then(async () => {
        await this.$axios.post('/admin/api_key/delete', { api_key: row.api_key });
        this.$message.success('已删除');
        this.onSearch();
      });
    },
    async onUnblock(row) {
      this.$confirm('确定要解除该API Key的封禁吗？', '提示', { type: 'warning' }).then(async () => {
        await this.$axios.post('/admin/api_key/unblock', { api_key: row.api_key });
        this.$message.success('已解除封禁');
        this.onSearch();
      });
    },
    async onReset(row) {
      this.$confirm('确定要重置该API Key吗？重置后将生成新的API Key。', '提示', { type: 'warning' }).then(async () => {
        try {
          const res = await this.$axios.post('/admin/api_key/reset', { api_key: row.api_key });
          if (res && res.code === 200) {
            this.$message.success('API Key已重置');
            this.newApiKey = res.new_api_key; // 从响应中获取新的API Key
            this.resetDialogVisible = true; // 显示对话框
            this.onSearch();
          } else {
            this.$message.error(res?.message || '重置失败');
          }
        } catch (err) {
          this.$message.error('重置API Key失败: ' + (err.message || '未知错误'));
        }
      });
    },
    resetSearch() {
      this.searchForm = { userSearch: '', status: '', page: 1, pageSize: 20 };
      this.userSearchType = 'username'; // 重置搜索类型
      this.onSearch();
    },
    copyNewApiKey() {
      const input = document.createElement('input');
      input.value = this.newApiKey;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('API Key已复制到剪贴板！');
    }
  }
}
</script>

<style scoped>
.admin-api-key-manage {
  max-width: 1200px;
  margin: 32px auto;
  background: #fff;
  padding: 24px;
  border-radius: 8px;
}

.user-search-container {
  display: flex;
  align-items: center;
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
}

.action-buttons .el-button {
  margin: 0;
  padding: 5px 10px;
  transition: all 0.3s;
}

.action-buttons .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .admin-api-key-manage {
    padding: 16px;
    margin: 16px auto;
  }
  
  .el-form {
    display: flex;
    flex-direction: column;
  }
  
  .el-form-item {
    margin-bottom: 10px;
  }
  
  .user-search-container {
    width: 100%;
  }
}

.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 0;
}

.mobile-card {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 14px 12px 10px 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.mobile-card-title {
  font-weight: 600;
  font-size: 15px;
  color: #333;
  margin-bottom: 10px;
  word-break: break-all;
}

.mobile-card-row {
  margin-bottom: 8px;
}

.mobile-card-actions {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.no-data-tip {
  text-align: center;
  color: #909399;
  padding: 20px 0;
}
</style> 